import type { ShoppingCartResponse } from "@models/shoppingCart";

/**
 * The number a cart badge shows: units (the lines' quantities summed), not lines (B-15). The
 * Cart and Checkout count "Items" in units ("Subtotal (700 Items)"), so a badge counting lines
 * would name a different number for the same cart. Every line counts, restricted ones too:
 * they are in the cart. 0 with no cart read yet, or a cart shell with no items array.
 */
export const cartUnitCount = (cart: ShoppingCartResponse | null): number =>
    cart?.items?.reduce((sum, item) => sum + item.quantity, 0) ?? 0;
